import type { GetApiResponseByUrl } from '@crossbeam/openapi';

type PartnerMappingRuleType =
  GetApiResponseByUrl<'/v0.1/partners-internal-populations'>['items'][number];

/** A feed's Partner Mapping rule is the one defined on its account source. */
export function findPartnerMappingRule(
  rules: PartnerMappingRuleType[],
  feedId: number,
  accountSourceId: number | undefined,
) {
  return rules.find(
    (rule) => rule.feed_id === feedId && rule.source_id === accountSourceId,
  );
}

export function hasPartnerMappingFilter(rule: PartnerMappingRuleType) {
  return Object.values(rule.source_filter_expressions ?? {}).some(
    (expression) => expression.filter_parts?.length,
  );
}
